/**
 * Generated from ch9_p06.fla
 */
export function ch9_p06(this: Ich9_p06) {
	const lightBack = this.lightBack;
	if (!lightBack[0] && lightBack.elementFactory) {
		lightBack[0] = lightBack.elementFactory(0,undefined);
	}
	if (lightBack[0]) {
		ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightoutsideglow.call(lightBack[0] as Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightoutsideglow);
		lightBack[0].x = 775.75;
		lightBack[0].y = 384;
		lightBack[0].width = 819.50;
		lightBack[0].height = 768.00;
		lightBack[0].alpha = 1;
		if (lightBack[0].onLayout) lightBack[0].onLayout();
	}
	if (!lightBack[1] && lightBack.elementFactory) {
		lightBack[1] = lightBack.elementFactory(1,undefined);
	}
	if (lightBack[1]) {
		ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightoutsideglowcopy.call(lightBack[1] as Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightoutsideglowcopy);
		lightBack[1].x = 775.75;
		lightBack[1].y = 384;
		lightBack[1].width = 819.50;
		lightBack[1].height = 768.00;
		lightBack[1].alpha = 1;
		if (lightBack[1].onLayout) lightBack[1].onLayout();
	}
	const lightFront = this.lightFront;
	if (!lightFront[0] && lightFront.elementFactory) {
		lightFront[0] = lightFront.elementFactory(0,undefined);
	}
	if (lightFront[0]) {
		ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightbottomLayer95.call(lightFront[0] as Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightbottomLayer95);
		lightFront[0].x = 832;
		lightFront[0].y = 461.25;
		lightFront[0].width = 1664.00;
		lightFront[0].height = 613.50;
		lightFront[0].alpha = 1;
		if (lightFront[0].onLayout) lightFront[0].onLayout();
	}
	if (!lightFront[1] && lightFront.elementFactory) {
		lightFront[1] = lightFront.elementFactory(1,undefined);
	}
	if (lightFront[1]) {
		ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightbottomLayer95copy.call(lightFront[1] as Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightbottomLayer95copy);
		lightFront[1].x = 832;
		lightFront[1].y = 461.25;
		lightFront[1].width = 1664.00;
		lightFront[1].height = 613.50;
		lightFront[1].alpha = 1;
		if (lightFront[1].onLayout) lightFront[1].onLayout();
	}
	const bg = this.bg;
	ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const holly = this.holly;
	ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_holly.call(this.holly);
	holly.x = 865.25;
	holly.y = 768;
	holly.width = 407.50;
	holly.height = 616.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const frameRight = this.frameRight;
	ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeRRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeRLayer32copy.call(this.linesRight);
	linesRight.x = 1648.5;
	linesRight.y = 383.25;
	linesRight.width = 292.50;
	linesRight.height = 766.50;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeLLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeLLayer94copy2.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 384;
	linesLeft.width = 326.00;
	linesLeft.height = 768.00;
	linesLeft.alpha = 0.26;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_bg(this: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p06_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightoutsideglow(this: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightoutsideglow) {
	if (this.setLayoutTexture) this.setLayoutTexture("glow", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightoutsideglowcopy(this: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightoutsideglowcopy) {
	if (this.setLayoutTexture) this.setLayoutTexture("glowcopy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_holly(this: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p06_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightbottomLayer95(this: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightbottomLayer95) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer95", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightbottomLayer95copy(this: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightbottomLayer95copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer95copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeRRframe(this: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeRRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeRLayer32copy(this: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeRLayer32copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer32copy", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
function ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeLLframe(this: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeLLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeLLayer94copy2(this: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeLLayer94copy2) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer94copy2", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
interface Ich9_p06Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich9_p06Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich9_p06Sprite extends Ich9_p06Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich9_p06Text extends Ich9_p06Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich9_p06Polygon extends Array<number> {
}
interface Ich9_p06 {
	readonly lightBack: Ich9_p06Array<Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightoutsideglow|Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightoutsideglowcopy>;
	readonly lightFront: Ich9_p06Array<Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightbottomLayer95|Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightbottomLayer95copy>;
	readonly bg: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_bg;
	readonly holly: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_holly;
	readonly frameRight: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeRRframe;
	readonly linesRight: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeRLayer32copy;
	readonly frameLeft: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeLLframe;
	readonly linesLeft: Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeLLayer94copy2;
}
interface Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_bg extends Ich9_p06Sprite {
}
interface Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightoutsideglow extends Ich9_p06Sprite {
}
interface Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightoutsideglowcopy extends Ich9_p06Sprite {
}
interface Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_holly extends Ich9_p06Sprite {
}
interface Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightbottomLayer95 extends Ich9_p06Sprite {
}
interface Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_lightbottomLayer95copy extends Ich9_p06Sprite {
}
interface Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeRRframe extends Ich9_p06Sprite {
}
interface Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeRLayer32copy extends Ich9_p06Sprite {
}
interface Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeLLframe extends Ich9_p06Sprite {
}
interface Ich9_p06_hh_ch9_72dpi_p061psdAssetchp9_p06_wcframeLLayer94copy2 extends Ich9_p06Sprite {
}
